module.exports = __webpack_public_path__ + "img/marquee-1.f8660e20.png";